var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "customer-tree" },
    _vm._l(_vm.list, function (item) {
      return _c("li", { key: item.deptId }, [
        _c(
          "span",
          {
            staticClass: "title",
            on: {
              click: function ($event) {
                return _vm.showUser(item)
              },
            },
          },
          [
            _c("a-icon", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !item.showUser,
                  expression: "!item.showUser",
                },
              ],
              attrs: { type: "caret-right" },
            }),
            _c("a-icon", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item.showUser,
                  expression: "item.showUser",
                },
              ],
              attrs: { type: "caret-down" },
            }),
            _vm._v(" " + _vm._s(item.deptName) + " "),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: item.showUser,
                expression: "item.showUser",
              },
            ],
          },
          [
            item.children
              ? _c(
                  "ul",
                  [
                    _c("tree", {
                      attrs: {
                        list: item.children,
                        selectedUser: _vm.selectedUser,
                        userName: _vm.userName,
                        detph: _vm.detph + 1,
                      },
                      on: { change: _vm.checkedUser },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "ul",
              _vm._l(item.userList, function (user) {
                return _c(
                  "li",
                  { key: user.userId },
                  [
                    _c(
                      "a-checkbox",
                      {
                        attrs: { checked: user.checked },
                        on: {
                          click: function ($event) {
                            return _vm.onChange(user)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(user.userName) + " ")]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }